import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnInit, Output, SimpleChange, SimpleChanges, ViewChild } from '@angular/core';
import { IDropdownField, YearDetailsModel, YearPickerDataModel } from './model/IDropdown';
import { Observable, Subject, } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { catchError, debounceTime, delay, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { FormControl } from '@angular/forms';
import { concat } from 'rxjs/observable/concat';
import { NgSelectComponent } from '@ng-select/ng-select';
import { OrdersService } from '../../services/orders/orders.service';

@Component({
  selector: 'app-dropdown-field-box',
  templateUrl: './dropdown-field-box.component.html',
  styleUrls: ['./dropdown-field-box.component.scss']
})
export class DropdownFieldBoxComponent implements OnInit, OnChanges {
  @Output() outputKeyword: EventEmitter<any> = new EventEmitter();
  @Output() tagOutputKeyword: EventEmitter<any> = new EventEmitter();
  @Output() searchKeyword: EventEmitter<string> = new EventEmitter();
  @Output() isValidation: EventEmitter<boolean> = new EventEmitter();
  @Output() onScrollEvent: EventEmitter<any> = new EventEmitter();
  @Output() onTabPress: EventEmitter<string> = new EventEmitter();
  @Output() onEnterPress: EventEmitter<string> = new EventEmitter();
  @Output() bulkPasteKeyword: EventEmitter<string[]> = new EventEmitter(); //added by BURHAN - 5-August-2026
  @Input() inputValue: any;
  @Input() noSearch: any;
  @Input() isSearchByApi: any = false;
  @Input() isSearchStatus: boolean;
  @Input() yearDropdownDetails: YearDetailsModel = {
    yearFrom: 2000,
    yearTo: 2030,
    isShowFromToYear: true
  }
  people$: Observable<any[]>;
  peopleLoading = false;
  customerId: any
  peopleInput$ = new Subject<string>();
  selectedPersons: any[] = <any>[{ name: 'Karyn Wright' }, { name: 'Other' }];
  @Input() fieldDetails: IDropdownField = {
    lable: 'Email',
    placeholder: 'Enter Email',
    isServerError: true,
    serverErrorText: 'Email is required',
    isSearch: true,
    dropdownList: [
      {
        name: 'option1',
        value: "1"
      },
      {
        name: 'option1',
        value: "1"
      },
      {
        name: 'option1',
        value: "1"
      }
    ]
  };
  @Input() formSubmitted: boolean = false;
  @Input() selectedItem: any;
  searchValue: any;
  @Input() disabled: boolean = false;
  @ViewChild('select') select: NgSelectComponent;
  private lastEmittedValue: any = null;

  @Input() appendToBody = false;  //added by fahim 30-01-2026

  constructor(private ngZone: NgZone, private el: ElementRef,
    private translate: TranslateService,
    private orderService: OrdersService) {
    this.peopleInput$.pipe(
      debounceTime(300), // Adjust the debounce time as needed (e.g., 300 milliseconds)
      // distinctUntilChanged()
    ).
      subscribe((newTerm) => {
        this.searchKeyword.emit(newTerm);
        this.searchValue = newTerm
      });
    this.people$ = this.peopleInput$.pipe(
      map((term) => this.searchPeople(term))
    )
  }
  ngOnInit(): void {
    if (this.fieldDetails.isYearDropdown) {
      this.fieldDetails.dropdownList = this.setYearDropdownList();
    }
  }

  private searchPeople(term: string | null): any[] {
    const searchTerm = term ? term : '';
    return this.fieldDetails.dropdownList.filter((person) => {
      return person.name.toLowerCase().startsWith(searchTerm.toLowerCase());
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ngZone.runOutsideAngular(() => {
      if ((!changes.fieldDetails && (changes.inputValue && changes.inputValue.firstChange))) {
        return;
      }

      let fieldDetails: any;
      if (!changes.fieldDetails) {
        fieldDetails = this.fieldDetails;
        this.people$ = of(this.fieldDetails.dropdownList);
      } else {
        fieldDetails = changes.fieldDetails.currentValue;
        this.people$ = of(this.fieldDetails.dropdownList);
      }
      if (fieldDetails.isFocus == true) {
        this.setFocus();
      }
      const matchingItem = fieldDetails.dropdownList && fieldDetails.dropdownList.find(item => {
        if (this.fieldDetails.isValueBind) {
          return (item.value === this.inputValue);
        } else {
          return item.name === this.inputValue;
        }
      });
      this.selectedItem = matchingItem;
      // if (!this.inputValue) {
      //   this.inputValue = null;
      // }

    });

  }

  // onSelect(event: any) {
  //   if (event) {
  //     if ((this.isSearchByApi || this.fieldDetails.isFullObject)
  //       && !this.fieldDetails.isMultipleSelect) {
  //       this.selectedItem = event;
  //       this.customerId = event.value
  //       this.inputValue = this.fieldDetails.isValueBind || this.fieldDetails.isValueBind == undefined ? event.value : event.name;
  //       this.orderService.setCustomerId(this.customerId);
  //       this.outputKeyword.emit(event);
  //     } else if (this.fieldDetails.isMultipleSelect) {
  //       this.inputValue = event;
  //       if (this.fieldDetails.isFullObject) {
  //         this.outputKeyword.emit(event);
  //       }
  //       else {
  //         const idList = event.map(x => x.value);
  //         this.outputKeyword.emit(idList);
  //       }
  //     }
  //     else {
  //       this.inputValue = this.fieldDetails.isValueBind || this.fieldDetails.isValueBind == undefined ? event.value : event.name;
  //       this.outputKeyword.emit(this.inputValue);
  //     }
  //   } else {
  //     this.outputKeyword.emit(event);
  //   }
  // }


  onSelect(event: any) {
    if (this.fieldDetails && this.fieldDetails.preventDuplicateEmit) {
      var valueToCompare;
      if (this.fieldDetails.isMultipleSelect) {
        valueToCompare = JSON.stringify(event);
      } else {
        valueToCompare = event && event.value;
      }

      if (this.lastEmittedValue === valueToCompare) {
        this.lastEmittedValue = null;
        this.inputValue = null;
        this.selectedItem = null;
        this.customerId = null;
        return;
      }

      this.lastEmittedValue = valueToCompare;
    }

    if (event) {
      if ((this.isSearchByApi || this.fieldDetails.isFullObject) && !this.fieldDetails.isMultipleSelect) {
        this.selectedItem = event;
        this.customerId = event.value;
        this.inputValue = this.fieldDetails.isValueBind || this.fieldDetails.isValueBind == undefined
          ? event.value : event.name;
        this.orderService.setCustomerId(this.customerId);
        this.outputKeyword.emit(event);
      } else if (this.fieldDetails.isMultipleSelect) {
        this.inputValue = event;
        if (this.fieldDetails.isFullObject) {
          this.outputKeyword.emit(event);
        } else {
          const idList = event.map(function (x) { return x.value; });
          this.outputKeyword.emit(idList);
        }
      } else {
        this.inputValue = this.fieldDetails.isValueBind || this.fieldDetails.isValueBind == undefined
          ? event.value : event.name;
        this.outputKeyword.emit(this.inputValue);
      }
    } else {
      this.outputKeyword.emit(event);
    }
  }




  // added by priya - 28/01/25
  // for tag (it took manually entered value as input value)
  onAddTag(newValue: string) {
    this.inputValue = newValue;
    this.tagOutputKeyword.emit(this.inputValue);
  }
  // ke

  translatorFn(value) {
    return this.translate.instant(value);
  }

  setYearDropdownList = (): Array<YearPickerDataModel> => {
    this.yearDropdownDetails.yearFrom = this.yearDropdownDetails.yearFrom ? this.yearDropdownDetails.yearFrom : (new Date().getFullYear() - 10);
    this.yearDropdownDetails.yearTo = this.yearDropdownDetails.yearTo ? this.yearDropdownDetails.yearTo : (new Date().getFullYear() + 10);

    const dropdownList: Array<YearPickerDataModel> = [];
    const yearTo = this.yearDropdownDetails.isShowFromToYear ? this.yearDropdownDetails.yearTo : this.yearDropdownDetails.yearTo + 1;
    for (let startYear = this.yearDropdownDetails.yearFrom; startYear < yearTo; startYear++) {
      let value: YearPickerDataModel;
      if (this.yearDropdownDetails.isShowFromToYear) {
        value = {
          name: startYear + "-" + (startYear + 1),
          startYear: startYear,
          endYear: (startYear + 1),
        }
      }
      else {
        value = {
          name: startYear,
          startYear: startYear,
          endYear: startYear,
        }
      }
      dropdownList.push(value);
    }
    return dropdownList;
  }

  customSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.name.toLowerCase().indexOf(term) > -1;
  }

  // onFocus(event){
  //   if(this.fieldDetails.isFocus == true){
  //     this.select.focus();
  //   }
  //   console.log('event', event)
  // }

  onTab(event) {
    this.onTabPress.emit(event);
  }

  onEnter(event) {
    this.onEnterPress.emit(event);
  }

  onSearch(event) {
    this.searchKeyword.emit(event);
  }

  onScrollToEnd() {
    this.onScrollEvent.emit(this.searchValue);
  }

  onScroll({ end }) {
    // if (this.isSearchStatus || this.photos.length <= this.photosBuffer.length) {
    //     return;
    // }

    // if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.photosBuffer.length) {
    //     this.fetchMore();
    // }
  }

  setFocus = () => {
    this.select.focus();
    console.log('Dropdown successfully focused!');
  }

   //added by fahim 30-01-2026
  get appendTarget() {
    return this.appendToBody ? 'body' : null;
  }

  //added by BURHAN - 5-August-2026
  addTagFn = (term: string) => {
    if (!this.fieldDetails || !this.fieldDetails.enableBulkPaste) return null as any;
    term = (term || '').toString().trim();
    if (!term) return null as any;

    if (this.fieldDetails.enableBulkValidation) {
      const list = this.fieldDetails.dropdownList || [];
      for (let i = 0; i < list.length; i++) {
        if (String(list[i].value).toLowerCase() === term.toLowerCase() ||
          String(list[i].name).toLowerCase() === term.toLowerCase()) {
          return list[i];
        }
      }
      return null; // invalid hai to chip hi nahi banega
    }
    return { name: term, value: term };
  }

  onBulkPaste(event: ClipboardEvent) {
    if (!this.fieldDetails || !this.fieldDetails.enableBulkPaste) return;
    if (!this.fieldDetails.isMultipleSelect) return;
    const text = event.clipboardData.getData('text');
    if (!text || !text.trim()) return;
    if (!/[\n\r,;\t ]/.test(text)) return; // single value hai to normal flow

    event.preventDefault();
    event.stopPropagation();
    this.processBulkPasteText(text);
  }

  processBulkPasteText(text: string) {
    if (!this.fieldDetails ||!this.fieldDetails.enableBulkPaste) return;

    // 1. Split by space, comma, newline, tab, semicolon
    const rawParts = text.split(/[\s,;\n\r\t]+/);
    const cleanedParts: string[] = [];
    for (let i = 0; i < rawParts.length; i++) {
      let p = (rawParts[i] || '').trim();
      p = p.replace(/^,+|,+$/g, '');
      if (p) cleanedParts.push(p);
    }

    // 2. Duplicate hatao (case-insensitive)
    const seen: any = {};
    const uniqueParts: string[] = [];
    for (let i = 0; i < cleanedParts.length; i++) {
      const key = cleanedParts[i].toLowerCase();
      if (!seen[key]) {
        seen[key] = true;
        uniqueParts.push(cleanedParts[i]);
      }
    }

    if (uniqueParts.length === 0) return;

    // 3. ==== VALIDATION MODE (dropdown value se check) ====
    // agar enableBulkValidation true hai to yahi se parent ko bhej do
    // parent API se check karke hi chip banayega
    if (this.fieldDetails.enableBulkValidation) {
      this.bulkPasteKeyword.emit(uniqueParts);
      return;
    }

    // 4. ==== NORMAL MODE (bina validation - purana logic) ====
    let currentVals: string[] = [];
    if (Array.isArray(this.inputValue)) {
      for (let i = 0; i < this.inputValue.length; i++) {
        const c = this.inputValue[i];
        const v = typeof c === 'string'? c : (c && (c.value || c.name) || '');
        if (v) currentVals.push(v);
      }
    }

    // merge + dedup
    const mergedMap: any = {};
    const allVals: string[] = [];
    const combined = currentVals.concat(uniqueParts);
    for (let i = 0; i < combined.length; i++) {
      const key = combined[i].toLowerCase();
      if (!mergedMap[key]) {
        mergedMap[key] = true;
        allVals.push(combined[i]);
      }
    }

    if (allVals.length === 0) return;

    // dropdownList me add karo taki chip dikhe
    const existingMap: any = {};
    const list = this.fieldDetails.dropdownList || [];
    for (let i = 0; i < list.length; i++) {
      existingMap[String(list[i].value).toLowerCase()] = true;
    }
    const toAdd: any[] = [];
    for (let i = 0; i < allVals.length; i++) {
      if (!existingMap[allVals[i].toLowerCase()]) {
        toAdd.push({ name: allVals[i], value: allVals[i] });
      }
    }
    if (toAdd.length > 0) {
      this.fieldDetails.dropdownList = list.concat(toAdd);
      this.people$ = of(this.fieldDetails.dropdownList);
    }

    const newObjects: any[] = [];
    for (let i = 0; i < allVals.length; i++) {
      const v = allVals[i];
      let found: any = null;
      for (let j = 0; j < this.fieldDetails.dropdownList.length; j++) {
        if (String(this.fieldDetails.dropdownList[j].value).toLowerCase() === String(v).toLowerCase()) {
          found = this.fieldDetails.dropdownList[j];
          break;
        }
      }
      newObjects.push(found || { name: v, value: v });
    }

    this.inputValue = newObjects;
    this.onSelect(newObjects);
    const that = this;
    setTimeout(function () { that.peopleInput$.next(''); }, 50);
  }
  //end by BURHAN
}
